export default "/assets/image_el-e8e631691987efe8700d1f5a87bae6d8d5c6368c3cd7a47a93db0a6c08d4d3d2.svg";